(function () {
    'use strict';

    angular
        .module('AsyncPanel')
        .factory('action-test-get-model', actionFunc);

    function actionFunc($timeout) {
        return () => {
            return $timeout(() => {
                return {
                    test1: '1',
                    test2: 2
                };
            }, 1000);
        };
    }
})();